import { conceptmap } from '../constants';

const initialState = {
  conceptmap: [],
  isFetching: false
};

export function widgetConceptmap(state = initialState, action) {
  switch (action.type) {
    case conceptmap.REQUEST_CONCEPTMAP:
      return{
        ...state,
        isFetching: true,
        lastUpdated: action.receivedAt 
      }
    case conceptmap.RECEIVE_CONCEPTMAP:
      return{
        ...state,
        isFetching: false,
        conceptmap: action.conceptmap,
        lastUpdated: action.receivedAt
      }
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/widgetConceptmap.reducer.js